import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/public/index'
/*
*  Chrome51 版本以后，Chrome 增加了新的事件捕获机制－Passive Event Listeners；
Passive Event Listeners：就是告诉前页面内的事件监听器内部是否会调用preventDefault函数来阻止事件的默认行为，以便浏览器根据这个信息更好地做出决策来优化页面性能。当属性passive的值为true的时候，代表该监听器内部不会调用preventDefault函数来阻止默认滑动行为，Chrome浏览器称这类型的监听器为被动（passive）监听器。目前Chrome主要利用该特性来优化页面的滑动性能，所以Passive Event Listeners特性当前仅支持mousewheel/touch相关事件。
*/
import 'default-passive-events'
/*防止连续点击 */
import directives from '@/utils/point'
Vue.use(directives)

Vue.directive('el-select-loadmore1', { // 指令懒加载
  // bind表示这个自定义指令一绑定到dom上，就开始自动执行
  bind(el: any, binding: any) {
    // 获取element-ui定义好的scroll盒子
    const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
    SELECTWRAP_DOM.addEventListener('scroll', function () {
      /**
       * scrollHeight 获取元素内容高度(只读)
       * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
       * clientHeight 读取元素的可见高度(只读)
       * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
       * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
       */
      const condition = this.scrollHeight - this.scrollTop-1 <= this.clientHeight;
      if (condition) {
        binding.value();
      }
    });
  },
  // 表示dom插入到页面上的时候自动执行
  // 这些函数都有两个参数，一个是el(使用自定义指令的元素), 一个是binding(记录自定义指令信息的对象)
  inserted(el, binding) {
    el.focus()
  },
  // 表示自定义指令后面的值更新的时候，自动执行
  update() {
    // console.log(this.scrollHeight , this.scrollTop, '11');
  }
})


Vue.config.productionTip = false
// 校验文件类型
Vue.prototype.fileExtension = function (type: any) {
  return type.substring(type.lastIndexOf('.') + 1)
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
